import { render, staticRenderFns } from "./shippingDetail.vue?vue&type=template&id=600adecc&scoped=true&"
import script from "./shippingDetail.js?vue&type=script&lang=js&"
export * from "./shippingDetail.js?vue&type=script&lang=js&"
import style0 from "./shippingDetail.scss?vue&type=style&index=0&id=600adecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600adecc",
  null
  
)

export default component.exports